module.exports = __webpack_public_path__ + "static/media/E-add.e9b801f7.svg";